/** Where the issue's location stands against its level's current map (PT-7117). */
export enum IssueLocationOnMap {
  /** No pin and no area. */
  notLocated = 'notLocated',
  onCurrentVersion = 'onCurrentVersion',
  /** On an outdated version of the documentation the level shows. */
  onOtherVersion = 'onOtherVersion',
  /** On a withdrawn version of the documentation the level shows (or the documentation is withdrawn). */
  onWithdrawnVersion = 'onWithdrawnVersion',
  /** On a documentation the level no longer shows. */
  onPreviousMap = 'onPreviousMap',
}

/** On a version other than the current one, whether outdated or withdrawn. */
export function isLocatedOnOtherVersion(locationOnMap: IssueLocationOnMap): boolean {
  return locationOnMap === IssueLocationOnMap.onOtherVersion || locationOnMap === IssueLocationOnMap.onWithdrawnVersion;
}

/** Located on another version or another map than the level's current one: the location may be confirmed on it. */
export function isLocatedOnOutdatedMap(locationOnMap: IssueLocationOnMap): boolean {
  return isLocatedOnOtherVersion(locationOnMap) || locationOnMap === IssueLocationOnMap.onPreviousMap;
}

export function isNotLocated(locationOnMap: IssueLocationOnMap): boolean {
  return locationOnMap === IssueLocationOnMap.notLocated;
}
